import React, { useEffect, useState } from 'react'

import CommunicationSelectControl from './CommunicationSelectControl'
import InfoTooltip from '../shared/InfoTooltip'
import { LocalForm } from 'react-redux-form'
import { entity as checklistItems } from '../../ducks/checklistItems'
import duckify, { singleDuck } from '../../utils/duckify'
import registerComponent from '../../utils/registeredComponent'

const ChecklistSnippetEditor = ({ allDucksReady, checklistItem = {}, checklist: { field }, ...props }) => {
  const [modelState, setModelState] = useState([])

  useEffect(() => {
    if (allDucksReady) {
      field.permissions = checklistItem.permissions
      setModelState(checklistItem.permissions)
    }
  }, [allDucksReady])

  useEffect(() => {
    document.getElementsByClassName("checklist-item-edit-permissions")[0].value = modelState
  }, [modelState])

  return (
    allDucksReady &&
    <LocalForm
      onChange={values => setModelState(values.permissions)}
    >
      <div className="control-group">
        <label htmlFor="" className="control-label">{field.displayName}</label>
        <div className="controls">
          <div className="row">
            <span className="col-20">
              <CommunicationSelectControl field={field} model={`.${field.canonicalName}`} />
            </span>
            <span className="col-2 snippet-attribute-help">
              <InfoTooltip postNbsp placement={"top"}>{field.tooltip}</InfoTooltip>
            </span>
          </div>
        </div>
      </div>
    </LocalForm>
  )
}

const mapDucksToProps = props => {
  const checklistId = props.checklist.checklistItem.checklistId
  return {
    checklistItem: singleDuck(checklistItems, checklistId),
    checklistItems
  }
}

export default registerComponent("ChecklistSnippetEditor")(duckify(mapDucksToProps)(ChecklistSnippetEditor))
